import { useAsyncData, useRequestURL } from '#imports'

import { getAsyncDataKey } from '@backmarket/nuxt-module-http-v2/getAsyncDataKey'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { usePageParamsFromRoute } from '~/scopes/cms/composables/usePageParamsFromRoute'
import { useSetCMSPageCacheTagHeader } from '~/scopes/cms/composables/useSetCMSPageCacheTagHeader'

export async function useFetchArticleThroughExperienceLayer() {
  const $httpFetch = useHttpFetch()
  const { pageName } = usePageParamsFromRoute()
  const requestURL = useRequestURL()
  const { setCMSCacheTagHeader } = useSetCMSPageCacheTagHeader()

  const { data, error, ...rest } = await useAsyncData(
    getAsyncDataKey(`cms-page-content-article-${pageName}`, { pageName }),
    () =>
      $httpFetch('/front-office/content/page/article/:pageName', {
        pathParams: { pageName },
        query: { source_url: requestURL.pathname },
        // necessary to always target the server endpoint (on DSE and local)
        baseURL: '',
      }),
    {
      transform: (response) => {
        return {
          ...response,
          updateDate: response.updateDate
            ? new Date(response.updateDate)
            : undefined,
        }
      },
    },
  )

  setCMSCacheTagHeader({
    pageType: 'article',
    pageName,
    pageCategory: undefined,
  })

  return {
    data,
    error,
    ...rest,
  }
}
